<template>
  <div class="category-preview">
    <div v-if="error" class="placeholder" @click="loadCategories">分类加载失败，点击重试</div>
    <div v-else-if="!groups.length" class="placeholder">请在店铺装修列表顶部点击「全局分类配置」</div>
    <template v-else>
      <div class="tabs">
        <span v-for="(group, index) in groups" :key="group.id" :class="{ active: selectedGroup === index }" @click="selectedGroup = index; selectedCategory = 0">{{ group.name || '一级分组' }}</span>
      </div>
      <div class="tabs secondary">
        <span v-for="(category, index) in categories" :key="category.id || category.category_id" :class="{ active: selectedCategory === index }" @click="selectedCategory = index">{{ category.alias || category.category_name || '二级分类' }}</span>
      </div>
      <div class="goods-placeholder">
        <div v-for="index in 4" :key="index" class="goods-card">
          <div class="goods-image"><i class="el-icon-goods"/></div>
          <p>{{ activeCategoryName }}商品</p>
          <small>按关联分类实时展示</small>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { getGlobalCategories } from '@/api/pages'
export default {
  name: 'CategoryGoodsPreview',
  data() { return { groups: [], error: false, selectedGroup: 0, selectedCategory: 0, requestVersion: 0 } },
  mounted() {
    this.loadCategories()
    window.addEventListener('focus', this.loadCategories)
  },
  beforeDestroy() {
    this.requestVersion += 1
    window.removeEventListener('focus', this.loadCategories)
  },
  methods: {
    async loadCategories() {
      const version = ++this.requestVersion
      this.error = false
      try {
        const config = await getGlobalCategories()
        if (version === this.requestVersion) this.groups = config.groups || []
      } catch (e) {
        if (version === this.requestVersion) this.error = true
      }
    }
  },
  computed: {
    categories() { return (this.groups[this.selectedGroup] || {}).categories || [] },
    activeCategoryName() {
      const item = this.categories[this.selectedCategory] || {}
      return item.alias || item.category_name || '分类'
    }
  },
  watch: {
    groups() { this.selectedGroup = 0; this.selectedCategory = 0 }
  }
}
</script>

<style scoped>
.category-preview { background: #f7f7f7; }
.tabs { display: flex; overflow-x: auto; background: #fff; white-space: nowrap; }
.tabs span { padding: 14px 22px; color: #999; cursor: pointer; }
.tabs .active { color: #222; font-weight: bold; border-bottom: 2px solid #333; }
.secondary { justify-content: flex-start; border-top: 1px solid #f7f7f7; }
.goods-placeholder { display: flex; flex-wrap: wrap; gap: 10px; padding: 10px; }
.goods-card { width: calc(50% - 5px); background: #fff; padding: 8px; box-sizing: border-box; }
.goods-image { height: 140px; display: flex; align-items: center; justify-content: center; font-size: 48px; color: #ddd; }
.goods-card p { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.goods-card small, .placeholder { color: #999; }
.placeholder { text-align: center; padding: 48px 12px; }
</style>
